import { FunctionComponent, memo } from "react";
import { IProps } from "./spelling-configuration-language-cell.types";

import { displayLanguageName } from "./spelling-configuration-language-cell.utilities";
import "./spelling-configuration-language-cell.scss";

/**
 * Display exemption language name
 * @param props.languageIsoCode
 * @param props.languages
 * @returns Language name or "unknown" or "none"
 */
const SpellingConfigurationLanguageCell: FunctionComponent<IProps> = ({ languages, languageIsoCode }) => {
    return (
        <>
            {typeof languageIsoCode === "string" ? (
                <div>{displayLanguageName(languageIsoCode, languages)}</div>
            ) : (
                <div>All</div>
            )}
        </>
    );
};

export default memo(SpellingConfigurationLanguageCell);
